import { useEffect, useState } from "react";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";

interface UseAddressSearchProps {
  updateFn: (updater: (prevItem: any) => any) => void;
  fieldKey: string;
  initialValue?: string;
}

const useAddressSearch = ({
  updateFn,
  initialValue,
  fieldKey,
}: UseAddressSearchProps) => {
  const [activeFieldKey, setActiveFieldKey] = useState<string | null>(null);
  const [addressInputs, setAddressInputs] = useState<Record<string, string>>(
    {}
  );

  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = usePlacesService({
    apiKey: "AIzaSyCU9qZlMZtXtxKvRJi-NRNJtPJF0p7DpYo", // reemplazalo por variable de entorno
  });

  useEffect(() => {
    if (initialValue) {
      setAddressInputs((prev) => ({
        ...prev,
        [fieldKey]: initialValue,
      }));
    }
  }, [fieldKey, initialValue]);

  useEffect(() => {
    return () => {
      setAddressInputs({});
    };
  }, [fieldKey]);

  const getAddressComponent = (placeDetails: any, type: string) => {
    const component = placeDetails?.address_components?.find((c: any) =>
      c.types.includes(type)
    );
    return component ? component.long_name : "";
  };

  const handleSelectAddress =
    (fieldKey: string, targetField: string) => (_: string, option: any) => {
      if (!activeFieldKey) return;

      placesService?.getDetails(
        { placeId: option.key },
        (placeDetails: any) => {
          const address = `${getAddressComponent(
            placeDetails,
            "route"
          )}, ${getAddressComponent(placeDetails, "street_number")}`;
          const city =
            getAddressComponent(placeDetails, "locality") ||
            getAddressComponent(placeDetails, "administrative_area_level_2");
          const postalCode = getAddressComponent(placeDetails, "postal_code");
          const country = getAddressComponent(placeDetails, "country");

          // Guardamos input visible
          setAddressInputs((prev) => ({
            ...prev,
            [fieldKey]: option.description,
          }));
          // Actualizamos la estructura real
          updateFn((prevItem: any) => {
            const updatedItem = { ...prevItem };
            updatedItem[targetField] = address;
            updatedItem[`${targetField}City`] = city;
            updatedItem[`${targetField}PostalCode`] = postalCode;
            updatedItem[`${targetField}Country`] = country;
            return updatedItem;
          });
        }
      );
    };

  const handleSearchAddress = (fieldKey: string) => (value: string) => {
    setActiveFieldKey(fieldKey);
    setAddressInputs((prev) => ({
      ...prev,
      [fieldKey]: value,
    }));
    getPlacePredictions({ input: value });
  };

  return {
    addressInputs,
    placePredictions,
    isPlacePredictionsLoading,
    handleSearchAddress,
    handleSelectAddress,
  };
};

export default useAddressSearch;
